module.exports = __webpack_public_path__ + "static/media/print.0fbae247.svg";